import axios from 'axios';
import * as ScholtenNegativesJson from "./data/scholtenNegatives.json";
import * as ScholtenPrintsJson from "./data/scholtenPrints.json";

export default axios.create({
  baseURL: process.env.REACT_APP_BACKEND,
  responseType: "json"
});

export const NLIApi = axios.create({
  baseURL: process.env.REACT_APP_NLI_API_BASE,
  responseType: "json"
});


export const ScholtenApi = axios.create({
  baseURL: process.env.REACT_APP_SCHOLTEN_API_BASE,
  responseType: "json"
});



export const ScholtenNegativesData = ScholtenNegativesJson?.default
export const ScholtenPrintsData = ScholtenPrintsJson?.default

